
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router"
import { useUserStore } from "@/store/user"
import { useMetaStore } from "@/store/meta"
import { sleep } from "@/utils/general"

export interface HeadMeta {
  name: string
  content: string
}

export interface Head {
  title?: string
  description?: string
}

export const getTitle = (page?: string) => `${ page ? page + " | " : "" }${process.env.VUE_APP_NAME}`

export const routeGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const userStore = useUserStore()
  const metaStore = useMetaStore()

  if(to.meta.authenticated === true && !userStore.authenticated) {
    next({ name: "Signin", query: { to: to.fullPath } })
  }
  else if(to.meta.authenticated === false && userStore.authenticated) {
    next({ name: "Home" })
  }
  else {
    metaStore.fromRoute(to)
    next()
  }
}

export const scrollBehavior = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  savedPosition: { left: number, top: number } | null
) => {
  const initial = { left: 0, top: 0 }

  if(to.name === from.name) {
    return false
  }
  
  await sleep(400)

  return savedPosition || initial
}
